/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

function InfoContent({ eleItem }) {
  const { t } = useTranslation('common');

  return (
    <div className="info-container d-flex ml-2">
      <span className="icon-info f-18" />
      <div className="info-content">
        {eleItem?.createdAt && (
          <p className="text-left m-0">
            <strong>{t('CARE_LABELS.TABLE.INFO_CONTENT.CREATED')}</strong> : {`${eleItem.createdBy} | `}
            {moment(eleItem.createdAt).format('DD-MMMM-YYYY, h:mm a')}
          </p>
        )}
        {eleItem.modifiedBy && ( // modifiedBy
          <p className="text-left m-0">
            <strong>{t('CARE_LABELS.TABLE.INFO_CONTENT.MODIFIED')}</strong> : {`${eleItem.modifiedBy} | `}
            {moment(eleItem.lastModifiedAt).format('DD-MMMM-YYYY, h:mm a')}
          </p>
        )}
      </div>
    </div>
  );
}

export default InfoContent;
